{
  "markread": "Позначити прочитаним",
  "newest": "Найновіші",
  "unread": "Непрочитані",
  "starred": "Позначені",
  "tags": "Мітки",
  "alltags": "Усі мітки",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 годину},other {# години}} тому",
  "minutes": "{0,plural,one {1 хвилину},other {# хвилини}} тому",
  "seconds": "{0,plural,one {1 секунду},other {# секунди}} тому",
  "star": "Позначити",
  "unstar": "Скасувати позначення",
  "mark": "Позначити прочитаним",
  "unmark": "Позначити непрочитаним",
  "load_img": "Показати зображення",
  "open_window": "Відкрити",
  "searchbutton": "Пошук",
  "sources": "Джерела",
  "source_add": "Додати джерело",
  "source_opml": "або імпортувати з OPML-файлу",
  "source_export": "експорт джерел",
  "source_edit": "Редагувати",
  "source_delete": "Видалити",
  "source_warn": "Дійсно видалити це джерело?",
  "source_new": "Нове не збережене джерело",
  "source_title": "Назва",
  "source_tags": "Мітки",
  "source_comma": "Розділені комою",
  "source_select": "Виберіть тип джерела",
  "source_type": "Тип",
  "source_save": "Зберегти",
  "source_cancel": "Скасувати",
  "source_saved": "збережено",
  "no_entries": "Записів не знайдено",
  "more": "Ще",
  "login": "Вхід",
  "login_username": "Ім'я користувача",
  "login_password": "Пароль",
  "no_title": "Без назви",
  "filter": "Фільтр",
  "online_count": "Елементи, доступні на сервері",
  "offline_count": "Елементи, доступні локально",
  "source_browse": "Огляд",
  "share_facebook_label": "Поділитися на Facebook",
  "error_check_log_file": "Виникла помилка, перевірте файл журналу \"{0}\".",
  "error_check_system_logs": "Виникла помилка, перевірте системні журнали.",
  "error_unwritable_logs": "Неможливо записати журнали.",
  "streamerror": "Елементи не завантажені, перезавантажити?",
  "error_edit_source": "Не вдалося зберегти зміни джерела:",
  "error_mark_items": "Не вдається позначити всі видимі елементи:",
  "error_star_item": "Неможливо позначити або зняти зірочку:",
  "error_logout": "Не вдалося вийти:",
  "error_saving_color": "Не вдається зберегти новий колір:",
  "error_sync": "Не вдалося синхронізувати останні зміни з сервера:",
  "error_unknown_source": "Невідомий ID джерела:",
  "error_load_tags": "Не вдалося завантажити мітки:",
  "error_unknown_tag": "Невідома мітка:",
  "error_refreshing_source": "Не вдається оновити джерела:",
  "error_mark_item": "Неможливо позначити/зняти позначку з елемента:",
  "error_offline_storage": "Помилка в офлайн-сховищі: {0}. Перезавантаження може допомогти. Наразі вимикається офлайн.",
  "days": "{0,plural,zero {сьогодні},one {вчора},other {# днів тому}}",
  "error_unauthorized": "Будь ласка, {link_begin}увійдіть{link_end}, щоб продовжити.",
  "share_native_label": "Поділитися",
  "share_twitter_label": "Поділитися в Twitter",
  "share_mastodon_label": "Поділитися на Mastodon",
  "source_deleting": "Видалення джерела…",
  "share_wordpress_label": "Поділитися на WordPress",
  "share_copy_label": "Скопіювати посилання в буфер обміну",
  "search_label": "Пошуковий запит",
  "share_mail_label": "Надіслати е-поштою",
  "searchremove": "Сховати пошук",
  "logoutbutton": "Вийти",
  "settingsbutton": "Налаштування",
  "loginbutton": "Увійти",
  "no_sources": "Джерела не налаштовані.",
  "source_filter": "Фільтр",
  "error_loading_stats": "Не вдається завантажити навігаційну статистику:",
  "source_menu": "Додаткові дії",
  "sources_leaving_unsaved_prompt": "Покинути налаштування з незбереженими змінами джерела?",
  "login_error_generic": "Не вдалося увійти: {errorMessage}",
  "experimental": "Експериментальні",
  "tag_change_color_button_title": "Змінити колір",
  "login_in_progress": "Спроба увійти…",
  "sources_refreshed": "Джерела оновлені",
  "error": "Виникла помилка",
  "sources_loading": "Завантаження джерел…",
  "login_invalid_credentials": "Неправильне ім'я користувача/пароль",
  "error_loading": "Виникла помилка при завантаженні:",
  "source_last_post": "Останній побачений допис",
  "refreshbutton": "Оновити джерела",
  "share_diaspora_label": "Поділитися на Diaspora",
  "share_wallabag_label": "Зберегти у Wallabag",
  "next": "Наступний",
  "source_saving": "Збереження змін джерела…",
  "entries_loading": "Завантаження записів…",
  "reload_list": "Оновити список",
  "share_pocket_label": "Зберегти в Pocket",
  "info_url_copied": "URL скопійовано в буфер обміну.",
  "offline_navigation_unavailable": "Перемикання міток і джерел наразі недоступне в режимі офлайн.",
  "source_warn_cancel_dirty": "Скасувати незбережені зміни?",
  "error_offline_storage_not_available": "Офлайн-сховище недоступне. Переконайтеся, що ваш веббраузер {0} підтримує API IndexedDB{1} і, якщо ви використовуєте браузер на базі Google Chrome, то ви не застосовуєте selfoss в режимі інкогніто.",
  "error_invalid_subsection": "Недійсний підрозділ:",
  "error_configuration": "Не вдається завантажити конфігурацію.",
  "error_share_native_abort": "Неможливо поділитися - або немає цілей, або ви їх скасували.",
  "error_share_native": "Неможливо поділитися.",
  "close_entry": "Закрити",
  "article_actions": "Дії",
  "article_reading_time": "{0} хв читання",
  "source_autotitle_hint": "Залиште порожнім, щоб отримати назву",
  "source_pwd_placeholder": "Без змін",
  "source_params_loading": "Завантажуємо параметри…",
  "source_refresh": "Оновити це джерело",
  "source_go_to_settings": "Відкрити в налаштуваннях",
  "login_offline": "Офлайн-сховище",
  "app_update": "selfoss оновлено, будь ласка, перезавантажте",
  "app_reload": "Перезавантажити",
  "error_session_expired": "Сеанс уже закінчився",
  "error_add_source": "Не вдалося додати джерело:",
  "error_delete_source": "Не вдалося видалити джерело:"
}
